import { parse } from "query-string";
import * as React from "react";
import { Link } from "react-router-dom";
import * as Const from "../../../Constants";
import { pushTo } from "../../../Helpers/links";
import * as Models from "../../../Models";
import salesInfoStore from "../../../Store/SalesInfoStore";

interface FilterProps {
    match: Models.Match;
    location: Models.Location;
    isModalSelectionMode: boolean;
}

export default function Filters(props: FilterProps) {
    const { toggleMobileMenu, mobileOverLayClose } = salesInfoStore();
    const { match, location, isModalSelectionMode } = props;
    function isActive(buttonType: string, activeTree: string): string {
        return buttonType === activeTree ? "--active" : "";
    }

    function changeFilter(filter: string): void {
        const queryParams: any = parse(location.search);

        toggleMobileMenu();

        pushTo({
            filter,
            queryParams,
        });
    }

    function advancedSearchClicked(): void {
        mobileOverLayClose();
    }

    const activeTree = match.params.filter;
    const siteButton: string = `btn btn-filter btn-filter${isActive(
        Const.SITE_TREE,
        activeTree
    )}`;
    const customerButton: string = `btn btn-filter btn-filter--middle btn-filter${isActive(
        Const.CUSTOMERS_TREE,
        activeTree
    )}`;
    const productsButton: string = `btn btn-filter btn-filter${isActive(
        Const.PRODUCTS_TREE,
        activeTree
    )}`;

    if (!isModalSelectionMode) {
        return (
            <div className="Filters">
                <div className="Filters__buttons">
                    <button
                        type="button"
                        className={siteButton}
                        onClick={() => changeFilter(Const.SITE_TREE)}
                    >
                        Sites
                    </button>
                    <button
                        type="button"
                        className={customerButton}
                        onClick={() => changeFilter(Const.CUSTOMERS_TREE)}
                    >
                        Customers
                    </button>
                    <button
                        type="button"
                        className={productsButton}
                        onClick={() => changeFilter(Const.PRODUCTS_TREE)}
                    >
                        Products
                    </button>
                </div>
                <Link
                    onClick={() => advancedSearchClicked()}
                    className="btn btn-primary"
                    to={{ pathname: "/search" }}
                >
                    Advanced search
                </Link>
            </div>
        );
    } else {
        return null;
    }
}
